import { smartPushState } from "../vendor/evented-history-state-functions";
import {
	getHubBaseUrl,
	isHubPaginatedPage,
	setHubFilterUrl,
} from "../vendor/url-helper-functions";
import {
	fetchFilteredGridPosts,
	applyInstantClientFilter,
	portfolioCardTemplate,
	exitHubFilteredMode,
} from "./grid-filter-ajax";
import {
	getPortfolioHubSearchTerm,
	handlePortfolioHubGridResult,
	applyPortfolioHubSearch,
} from "./portfolio-hub-live-search";

(function($) {
	$.ajaxSetup({ cache: false });
	var $page = $(".page");
	var $selectSearchWrapper = $("#select-and-search-wrapper");
	var $multiFilter = $("#multi-filter");
	var $select = $multiFilter.find(".select");
	var $parentFilters = $multiFilter
		.parents("#multi-filter-wrapper")
		.find(".parent-filters");
	var $childFilters = $parentFilters.find(".child-filters");
	var isPaginatedHub = !!$multiFilter.data("paginated");

	function applyFilterFromUrlParam() {
		if (!isPaginatedHub || window.ldcHubFilterUrlApplied || isHubPaginatedPage()) {
			$(".all-filter").addClass("is-selected");
			return;
		}

		var searchFilter = $.urlParam("filter");
		if (!searchFilter) {
			$(".all-filter").addClass("is-selected");
			return;
		}

		var $filteredElement = $childFilters.find(
			"[data-value='" + searchFilter + "']"
		);
		if (!$filteredElement.length) {
			return;
		}

		window.ldcHubFilterUrlApplied = true;
		window.ldcSkipFilterUrlUpdate = true;
		$parentFilters.find("*").removeClass("is-active is-selected");
		$filteredElement.addClass("is-selected");
		$filteredElement.parent().parent().prev().addClass("is-selected");
		$filteredElement.trigger("click");
	}

	$(document).ready(function() {
		if (isPaginatedHub) {
			exitHubFilteredMode();
		}
		applyFilterFromUrlParam();
	});

	$multiFilter.on("click", function() {
		if (window.matchMedia("(max-width: 639px)").matches) {
			$multiFilter.toggleClass("is-active");
			$parentFilters.toggleClass("is-active");
			$selectSearchWrapper.toggleClass("is-active");
		}
	});

	$parentFilters.find(".parent-filter").on("click", function() {
		var $this = $(this);
		if ($this.hasClass("is-active")) {
			$parentFilters.removeClass("is-active");
			$this.removeClass("is-active");
		} else {
			$parentFilters.addClass("is-active");
			$this.siblings(".parent-filter, .all-filter").removeClass("is-active");
			$this.addClass("is-active");
			$childFilters.removeClass("is-active");
			$this.next().toggleClass("is-active");
		}
	});

	$parentFilters.find(".all-filter").on("click", function() {
		if ($multiFilter.data("paginated")) {
			var liveSearch = ($multiFilter.data("post-type") || "") === "case-study"
				? getPortfolioHubSearchTerm()
				: "";
			if (liveSearch.length >= 2) {
				var $this = $(this);
				$parentFilters.find("*").removeClass("is-active is-selected");
				$this.addClass("is-selected");
				$select.text($this.text());
				$select.trigger("click");
				setHubFilterUrl("all");
				applyPortfolioHubSearch(liveSearch);
				return;
			}
			window.location.href = getHubBaseUrl();
			return;
		}
		var $this = $(this);
		$select.text($this.text());
		$this.siblings().removeClass("is-active");
		$this.addClass("is-active");
		$select.trigger("click");
		$(".grid-for-filtering .post__card").removeClass("is-hidden");
		exitHubFilteredMode();
	});

	$childFilters.find(".child-filter").on("click", function() {
		var $this = $(this);
		var skipUrlUpdate = !!window.ldcSkipFilterUrlUpdate;
		window.ldcSkipFilterUrlUpdate = false;
		$parentFilters.find("*").removeClass("is-selected");
		$this.addClass("is-selected");
		$this.parent().parent().prev().addClass("is-selected");

		var data = $this.data();
		var value = data.value;
		var filterby = data.filterby;
		var text = $this.text();

		$select.text(text);
		$select.trigger("click");
		$parentFilters.find("*").removeClass("is-active");

		if (!$multiFilter.data("paginated")) {
			$page.addClass("is-filtered");
			applyInstantClientFilter(filterby, value);
			smartPushState(filterby, value, null, false, true);
			return;
		}

		var postType = $multiFilter.data("post-type");
		var $grid = $('.grid-for-filtering[data-post-type="' + postType + '"]');
		if (!postType) {
			postType = "post";
			$grid = $(".grid-for-filtering");
		}

		if (value === "all") {
			return;
		}

		if ($(window).width() <= 768) {
			$("html, body").scrollTop(400);
		}

		if (!skipUrlUpdate) {
			setHubFilterUrl(value);
		}

		fetchFilteredGridPosts({
			postType: postType,
			term: value,
			taxonomy: filterby,
			filterby: filterby,
			value: value,
			$grid: $grid,
			instantFilter: false,
			cardTemplate: portfolioCardTemplate,
			searchTerm: postType === "case-study" ? getPortfolioHubSearchTerm() : "",
			emptyHtml: postType === "case-study" && getPortfolioHubSearchTerm().length >= 2 ? "" : undefined,
			onResult: postType === "case-study" ? handlePortfolioHubGridResult : null,
		});
	});
})(jQuery);
